import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import useEmpLandUse from "./useEmpLandUse";
import { siteInspRecommendation } from "../../citizen/TCPForms/data";
import {
  MainWrapper,
  PrimaryTabNewTheme,
  PrimaryTabs,
  PrimaryTabsWrapper,
  SubTab,
  SubTabNewTheme,
  SubTabs,
  SubTabsWrapper,
} from "../../citizen/AVPForms/components/StyledComponent";
import ViewSidebarIcon from "@mui/icons-material/ViewSidebar";
import { landUseSubTabDDocSecLabels } from "../../citizen/AVPForms/components/data";
import DocumentSection from "../PurchasableFAR/DocumentSection";
import ViewDocuments from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/ViewDocuments";
// import SubStep1 from "./Steps/SubStep1";
import PrimaryContent from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/PrimaryContent";
import CollapsibleHistory from "../NotingRemarks";
import ActionButtons from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/ActionButtons";
import RemarksEditor from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/RemarksEditor";
import DocUploader from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/DocUploader";
import SubmitButton from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/SubmitButton";
import Architect from "../../../../../templates/ApplicationDetails/RoleAccess/Architect";
import { BackButton } from "@egovernments/digit-ui-react-components";
import AllRemarksList from "../../../../../templates/Forms/AllRemarks";
import RecommendationRemarksComponent from "../RecommendationComponent";
import EmpTopBar from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/EmpTopBar";
import DscLetters from "../DigitalSignLetters";
import DocumentSectionLog from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/DocumentSectionLog";
import SubStep1 from "../../citizen/AVPForms/formComponents/registerProperty/Step1/SubStep1";
import SubStep3 from "../../citizen/AVPForms/formComponents/registerProperty/Step1/SubStep3";
import SubStep4 from "../../citizen/AVPForms/formComponents/registerProperty/Step1/SubStep4";

const EmpKYPPortal = ({ formData, submitAction, workflowDetails, userRolesArray }) => {
  const specialCondition = formData?.descriptionOfLand?.selectLandUse == "Conditional Permissible";
  const [activeTab, setActiveTab] = useState(Digit?.SessionStorage.get("KYP_CURRENT_TAB") || 0);
  const [subActiveTab, setSelectedSubTab] = useState(Digit?.SessionStorage.get("KYP_CURRENT_SUBTAB") || 0);
  const [initialDeveloperRemarks, setInitialDeveloperRemarks] = useState("");
  const [subActiveDocTab, setSelectedDocSubTab] = useState(0);
  const isApproved = formData?.status === "APPROVED";
  //   const {
  //     LANDUSE,
  //     ST_LABELS: subTabLabels,
  //     PT_LABELS: primaryTab,
  //     GENDER: genderList,
  //     SUBTYPE: landSubUses,
  //     LULIST: landUseListActivities,
  //     LUSCHEMELIST: landUsesSchemeList,
  //   } = useLocalizedData({
  //     LANDUSE: SidebarLabelsLandUse,
  //     ST_LABELS: landUseSubTabLabels,
  //     PT_LABELS: primaryTabLabels,
  //     GENDER: genderData,
  //     SUBTYPE: landSubUseTypes,
  //     LULIST: landUseList,
  //     LUSCHEMELIST: landUsesSchemeTypeList,
  //   });
  const subTabLabels = [{ label: "Applicant Information" }, { label: "LTP Information" }, { label: "Plot Details" }];

  const {
    handleChange,
    currentTab,
    tabList,
    currentAction,
    onRadioActionSelect,
    Modal,
    tenantId,
    handleSubmit,
    error,
    setError,
    updatedDocuments,
    setUpdatedDocuments,
    isCitizen,
    updateApiCall,
    t,
    isEE,
    isDa,
    remarks,
    setRemarks,
    getTabIndex,
    taxHead,
    setTaxHead,
    applicationDocs,
    declarationMessage,
    mandatoryCondition,
    setMandatoryCondition,
    declarationMessage2,
    actions,
    officerNocDetails,
    setOfficerNocDetails,
    isNoNoc,
    setIsNoNoc,
    handleChangeCheckBox,
    checked,
    setChecked,
    uploadedFile,
    setUploadedFile,
    isLowRiskCase,
    documentSection,
    initialUrl,
    department,
    setInitialUrl,
    iframeSrc,
    setIframeSrc,
    isPreviewLoading,
    setIsPreviewLoading,
    currentView,
    setCurrentView,
    handleDocView,
    userRoles,
    handleChangePayment,
    showToast,
    closeToast,
    handleChangeForward,
    handleNoWorkflow,
    handleNoWorkflowWithData,
    setDataRecommendation,
    setDataRecommendationDocument,
    onSelect,
    params,
    setParams,
    clearParams,
    dataRecommendationDocument,
    developerRemarksDocument,
    setDeveloperRemarksDocument,
    callKhasraDetailsApi,
    callDocumentDetailsAPI,
    khasraDetailsData,
    updateKhasraDetails,
    callNotingDetailsAPI,
    developerRemarks,
    setDeveloperRemarks,
    notingRemarksData,
    setNotingRemarksData,
    khasraRemarks,
    setKhasraRemarks,
    avpLogo,
    daLogo,
    documentRemarksData,
    setDocumentRemarksData,
  } = useEmpLandUse(formData, workflowDetails, userRolesArray);

  const handleTabChange = (nextTabNo, formData = null) => {
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("KYP_CURRENT_TAB", nextTabNo);
  };

  const handleSubTabChange = (nextSubTab, formData = null) => {
    setSelectedSubTab(nextSubTab);
    Digit.SessionStorage.set("KYP_CURRENT_SUBTAB", nextSubTab);
  };
  const handleSubDocTabChange = (nextSubTab, formData = null) => {
    setSelectedDocSubTab(nextSubTab);
  };

  const renderContent = () => {
    if (activeTab === 0) {
      switch (subActiveTab) {
        case 0:
          return (
            <SubStep1
              formData={formData}
              isEmployee={!isCitizen}
              handleSubTabChange={handleSubTabChange}
              applicationFlow={department}
              isApproved={true}
            />
          );
        case 1:
          return <SubStep3 formData={formData} isEmployee={!isCitizen} t={t} handleSubTabChange={handleSubTabChange} isApproved={true} />;
        case 2:
          return (
            <SubStep4
              formData={formData}
              isEmployee={!isCitizen}
              t={t}
              handleSubTabChange={handleSubTabChange}
              isApproved={true}
              handleNoWorkflow={handleNoWorkflowWithData}
            />
          );
        default:
          return null;
      }
    } else if (activeTab === 1 && !isCitizen) {
      switch (subActiveDocTab) {
        case 0:
          return (
            <React.Fragment>
              <div className="view-doc-container">
                <Button
                  variant="contained"
                  className="view-doc-btn"
                  onClick={handleDocView}
                  style={{ backgroundColor: "#157C4F", borderRadius: "15px", padding: "5px 10px" }}
                >
                  <span className="view-doc-icon">
                    <ViewSidebarIcon />
                  </span>
                  {currentView === "documents" ? "View all documents" : "View document section"}
                </Button>
              </div>
              {currentView === "documents" ? (
                <React.Fragment>
                  <DocumentSection
                    formData={params}
                    handleChange={handleTabChange}
                    setUpdatedDocuments={setUpdatedDocuments}
                    updatedDocuments={updatedDocuments}
                    setIsPreviewLoading={setIsPreviewLoading}
                    setDataRecommendation={setDataRecommendationDocument}
                    onSelect={onSelect}
                    handleNoWorkflow={handleNoWorkflow}
                    attachedDocs={params?.documents || formData?.documents}
                    docType="mandatory"
                    formType="LANDUSE"
                    developerRemarks={initialDeveloperRemarks || developerRemarksDocument}
                    callDocumentDetailsAPI={callDocumentDetailsAPI}
                    setError={setError}
                    ComposableComponent={(props) => (
                      <RecommendationRemarksComponent
                        title="Recommendation Details"
                        label="Recommendation"
                        name="recommendation" // just a field name, not value!
                        options={siteInspRecommendation}
                        defaultValue={dataRecommendationDocument}
                        extraLabel="Remarks"
                        setDeveloperRemarks={setDeveloperRemarksDocument}
                        developerRemarks={initialDeveloperRemarks || developerRemarksDocument}
                        setDataRecommendation={setDataRecommendationDocument}
                        error={error}
                        setError={setError}
                        {...props} // this includes `control`, injected later
                      />
                    )}
                  />
                  {!isCitizen && <DocumentSectionLog logData={documentRemarksData?.DetailDataRemarks} />}
                </React.Fragment>
              ) : (
                <ViewDocuments
                  documentSection={documentSection}
                  setIsPreviewLoading={setIsPreviewLoading}
                  iframeSrc={iframeSrc}
                  setIframeSrc={setIframeSrc}
                />
              )}
            </React.Fragment>
          );
        case 1:
          return (
            <React.Fragment>
              <DocumentSection
                formData={params}
                handleChange={handleTabChange}
                setUpdatedDocuments={setUpdatedDocuments}
                updatedDocuments={updatedDocuments}
                setIsPreviewLoading={setIsPreviewLoading}
                setDataRecommendation={setDataRecommendationDocument}
                onSelect={onSelect}
                handleNoWorkflow={handleNoWorkflow}
                callDocumentDetailsAPI={callDocumentDetailsAPI}
                attachedDocs={params?.documents || formData?.documents}
                docType="conditional"
              />
            </React.Fragment>
          );
      }
    } else if (activeTab === 1 && isCitizen) {
      return (
        <React.Fragment>
          <div className="view-doc-container">
            <Button
              variant="contained"
              className="view-doc-btn"
              onClick={handleDocView}
              style={{ backgroundColor: "#157C4F", borderRadius: "15px", padding: "5px 10px" }}
            >
              <span className="view-doc-icon">
                <ViewSidebarIcon />
              </span>
              {currentView === "documents" ? "View all documents" : "View document section"}
            </Button>
          </div>
          <ViewDocuments
            documentSection={documentSection}
            setIsPreviewLoading={setIsPreviewLoading}
            iframeSrc={iframeSrc}
            setIframeSrc={setIframeSrc}
          />
        </React.Fragment>
      );
    } else if (activeTab === 2 && isCitizen) {
      return (
        <React.Fragment>
          <Architect formData={formData} applicationDocs={applicationDocs} actions={actions} avpLogo={avpLogo} daLogo={daLogo} />

          <DocUploader uploadedFile={uploadedFile} setUploadedFile={setUploadedFile} />
          {actions?.[0]?.action === "MAKE_PAYMENT" && (
            <div style={{ marginTop: "15px" }}>
              <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={1}>
                <Box gridColumn="span 2"></Box>
                <Box gridColumn="span 8"></Box>
                <Box gridColumn="span 2">
                  <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={handleChangePayment}>
                    Payment
                  </Button>
                </Box>
              </Box>
            </div>
          )}

          {/* {actions?.[0]?.action === "MAKE_PAYMENT_APPLICATION_FEE" && (
                <div style={{ marginTop: "15px" }}>
                  <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={1}>
                    <Box gridColumn="span 2"></Box>
                    <Box gridColumn="span 8"></Box>
                    <Box gridColumn="span 2">
                      <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={handleChangePayment}>
                        Payment
                      </Button>
                    </Box>
                  </Box>
                </div>
              )} */}

          {actions?.[0]?.action === "FORWARD_TO_DEPARTMENT" && (
            <div style={{ marginTop: "15px" }}>
              <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={1}>
                <Box gridColumn="span 2"></Box>
                <Box gridColumn="span 6"></Box>
                <Box gridColumn="span 4">
                  <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={handleChangeForward}>
                    Forward To Department
                  </Button>
                </Box>
              </Box>
            </div>
          )}
        </React.Fragment>
      );
    } else if (activeTab === 2 && !isCitizen) {
      return (
        <React.Fragment>
          <PrimaryContent formData={formData} handleChange={handleChange} serviceName={"Know Your Property"} avpLogo={avpLogo} daLogo={daLogo} />
          {!isApproved && (
            <CollapsibleHistory
              formData={formData}
              callNotingDetailsAPI={callNotingDetailsAPI}
              developerRemarks={developerRemarks}
              setDeveloperRemarks={setDeveloperRemarks}
              notingRemarksData={notingRemarksData}
            />
          )}
          {formData?.status === "APPLY_FOR_DSC" && (
            <DscLetters formData={formData} handleChange={handleTabChange} isEmployee={!isCitizen} viewDrawing={false} pdfType={"LA"} />
          )}

          {/* {!isApproved && (
            <Card style={{ color: "red" }}>
              <CheckBox handleChangeCheckBox={handleChangeCheckBox} declarationMessage={declarationMessage} checked={checked} />
              {checked === false && <p>Please review the NOC checklist and select the applicable items to complete the form verification.</p>}
            </Card>
          )} */}
          {!isApproved && <ActionButtons actions={actions} currentAction={currentAction} onSelect={onRadioActionSelect} />}
          {!isApproved && <RemarksEditor setRemarks={setRemarks} remarks={remarks} setError={setError} error={error} />}
          {!isApproved && <DocUploader uploadedFile={uploadedFile} setUploadedFile={setUploadedFile} />}
          {!isApproved && <SubmitButton handleSubmit={handleSubmit} isLoading={updateApiCall.isLoading} />}
        </React.Fragment>
      );
    }

    // else if (activeTab === 3 && isCitizen) {
    //   return (
    //     <React.Fragment>
    //       <ChatboardCorrespondenceApplicant formData={formData} />
    //     </React.Fragment>
    //   );
    // }
    // else if (specialCondition && !isCitizen && activeTab === 4) {
    //   return (
    //     <React.Fragment>
    //       <SelectMandatoryConditions2 setMandatoryCondition={setMandatoryCondition} tenantId={tenantId} setCurrentTab={handleChange} />
    //     </React.Fragment>
    //   );
    // }
    //  else if (!specialCondition && !isCitizen && activeTab === 3) {
    //   return (
    //     <React.Fragment>
    //       <ChatBoard formData={formData} />
    //     </React.Fragment>
    //   );
    // }
    else if (activeTab === 3 && isCitizen) {
      return (
        <React.Fragment>
          <AllRemarksList remarkDataResps={workflowDetails?.data} formData={formData} />
        </React.Fragment>
      );
    }
    // else if (!specialCondition && !isCitizen && activeTab === 4) {
    //   return (
    //     <React.Fragment>
    //       <ChatBoard formData={formData} />
    //     </React.Fragment>
    //   );
    // }
    else if (activeTab === 3 && !isCitizen) {
      return (
        <React.Fragment>
          <AllRemarksList remarkDataResps={workflowDetails?.data} formData={formData} />
        </React.Fragment>
      );
    }
    // else if (!specialCondition && !isCitizen && activeTab === 5) {
    //   return (
    //     <React.Fragment>
    //       <AllRemarksList remarkDataResps={workflowDetails?.data} />
    //     </React.Fragment>
    //   );
    // } else if (specialCondition && !isCitizen && activeTab === 5) {
    //   return (
    //     <React.Fragment>
    //       <ChatBoard formData={formData} />
    //     </React.Fragment>
    //   );
    // } else if (specialCondition && !isCitizen && activeTab === 6) {
    //   return (
    //     <React.Fragment>
    //       <AllRemarksList remarkDataResps={workflowDetails?.data} formData={formData} />
    //     </React.Fragment>
    //   );
    // }
  };

  return (
    <React.Fragment>
      <BackButton />
      <MainWrapper className="main-panel-corner land-use-corner">
        {/* <HeaderContent applicationFlow={applicationFlow} /> */}

        {!isCitizen && <EmpTopBar formData={formData} />}
        <Box sx={{ overflowY: "auto" }}>
          <PrimaryTabsWrapper>
            {/* Tabs Header */}
            <PrimaryTabs value={activeTab} onChange={(e, i) => handleTabChange(i)} aria-label="Tab Group" variant="scrollable" scrollButtons="auto">
              <PrimaryTabNewTheme label="Application Data" />
              <PrimaryTabNewTheme label="Document Section" />
              <PrimaryTabNewTheme label="Take Action" />
              {/* <PrimaryTab label="NOC Checklist" /> */}
              {/* {specialCondition && !isCitizen ? <PrimaryTabNewTheme label="Conditions" /> : null} */}
              {/* <PrimaryTabNewTheme label="Chat-Board" /> */}
              <PrimaryTabNewTheme label="All Remarks" />
            </PrimaryTabs>
          </PrimaryTabsWrapper>
          {activeTab === 0 && (
            <SubTabsWrapper>
              <SubTabs
                value={subActiveTab}
                onChange={(e, i) => handleSubTabChange(i)}
                aria-label="Sub Tab Group"
                variant="scrollable"
                scrollButtons="auto"
              >
                {subTabLabels?.map((tab, index) => (
                  <SubTab key={index} label={tab.label} />
                ))}
              </SubTabs>
            </SubTabsWrapper>
          )}
          {activeTab === 1 && !isCitizen && (
            <SubTabsWrapper>
              <SubTabs
                value={subActiveDocTab}
                onChange={(e, i) => handleSubDocTabChange(i)}
                aria-label="Sub Tab Group"
                variant="scrollable"
                scrollButtons="auto"
              >
                {landUseSubTabDDocSecLabels.map((tab, index) => (
                  <SubTabNewTheme key={`${tab.text}.${index}`} label={tab.text} />
                ))}
              </SubTabs>
            </SubTabsWrapper>
          )}
          {/* <StyledDivider /> */}

          {renderContent()}
        </Box>
      </MainWrapper>
    </React.Fragment>
  );
};

export default EmpKYPPortal;
